<template>
  <v-list>
    <v-subheader>
      <v-icon class="mr-2">mdi-phone-outline</v-icon>Telefones
    </v-subheader>
    <v-list-item
      v-for="(telefone, i) in value"
      :key="`telefone-${i}`"
      v-on="
        editando
          ? { click: () => $store.commit('contato/editarTelefone', telefone) }
          : {}
      "
    >
      <v-list-item-content>
        <v-list-item-subtitle>
          {{ telefone.nome }}
          <span v-if="telefone.principal">&nbsp;(principal)</span>
          <v-icon v-if="telefone.celular" small class="ml-1" title="Celular">mdi-cellphone-android</v-icon>
          <v-icon v-if="telefone.whatsapp" small class="ml-1" title="Whatsapp">mdi-whatsapp</v-icon>
          <v-icon v-if="telefone.telegram" small class="ml-1" title="Telegram">mdi-telegram</v-icon>
        </v-list-item-subtitle>
        <v-list-item-title>
          {{ maskTelefone(telefone.numero) }}
          <v-tooltip bottom v-if="telefone.descricao !== ''">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small color="info" class="mr-1">mdi-information-outline</v-icon>
            </template>
            <span>{{ telefone.descricao }}</span>
          </v-tooltip>
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action v-if="editando">
        <v-btn icon @click.stop="del(i)">
          <v-icon>mdi-delete-outline</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-list-item v-if="editando">
      <v-list-item-content>
        <v-btn block text color="primary" @click="$store.commit('contato/novoTelefone')">
          <v-icon class="mr-2">mdi-phone-plus-outline</v-icon>NOVO TELEFONE
        </v-btn>
      </v-list-item-content>
    </v-list-item>
    <telefone-form @change="changeTelefone($event)" />
  </v-list>
</template>

<script>
import _ from "lodash";
import TelefoneForm from "./TelefoneForm";
import { build } from "../../lib/masks";
export default {
  components: { TelefoneForm },
  props: ["value", "editando"],
  methods: {
    changeTelefone(telefone) {
      let telefones = _.clone(this.value);
      if (!telefone.id) {
        telefone.id = new Date().getTime();
        telefones.push(telefone);
      } else {
        telefones = telefones.map(e => (e.id === telefone.id ? telefone : e));
      }

      if (telefone.principal) {
        telefones = telefones.map(e => {
          if (e == telefone) {
            return e;
          }
          e.principal = false;
          return e;
        });
      }

      this.$emit("input", telefones);
    },
    del(idx) {
      let telefones = _.clone(this.value);
      telefones.splice(idx, 1);
      this.$emit("input", telefones);
    },
    maskTelefone(val) {
      return build.phone(val);
    }
  }
};
</script>
